<div class="flex flex-col px-7 py-8 gap-2.5">
  <app-upload-window
    #uploadWindowComponent
    [disabled]="true"
    (chosenFiles)="registerFileUpload($event)"
    [hideUploadIcon]="true"
    [acceptFileTypes]="'.xlsx'"
  >
    <div class="border border-navy-300 rounded border-solid p-3 mt-0.5">
      <span
        [ngClass]="{ 'p-disabled': file }"
        (click)="uploadWindowComponent.hiddenFileInput.openFileUploadWindow()"
        class="text-blue-700 flex items-center gap-1.5 pointer-cursor"
      >
        <span class="text-xl icon-folded-file-upload flex items-center"></span>
        <span class="italic text-blue-700 font-bold text-size_l"> Click to upload </span>
      </span>
      @if (file) {
        <span class="flex items-center gap-5 pointer-cursor">
          <span class="text-blue-700 my-1.5 flex-1">
            {{ file.name | shortenFileName }}
          </span>
          <span
            (click)="removeFile()"
            class="icon-remove-circle-x text-size_icon text-blue-700 hover:text-yellow-500"
          ></span>
        </span>
      }
    </div>
  </app-upload-window>
  <span (click)="downloadXLSX()" class="text-blue-700 font-semibold pl-1 text-sm cursor-pointer">
    Download XLS Template</span
  >
</div>
